/**
 * "Frequently bought with" cart-drawer add-on (R65). Adds the fixed
 * accessory product (Premium Wash Bag) to the cart via the same AJAX
 * pattern Dawn's own <product-form> uses for every other Add to Cart
 * button (POST /cart/add.js requesting the cart-drawer's own sections,
 * then handing the response to the existing <cart-drawer> element's
 * renderContents() so the drawer re-renders exactly like any other cart
 * change -- no bespoke rendering logic, reuses Dawn's real machinery).
 */
if (!customElements.get('cart-drawer-addon')) {
  customElements.define(
    'cart-drawer-addon',
    class CartDrawerAddon extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('[data-flowra-addon-add]');
        this.errorEl = this.querySelector('.flowra-cart-addon-error');
        if (this.button) {
          this.button.addEventListener('click', this.onAddClick.bind(this));
        }
      }

      onAddClick(event) {
        event.preventDefault();
        if (this.button.getAttribute('aria-disabled') === 'true') return;

        const variantId = this.button.dataset.flowraAddonVariantId;
        if (!variantId) return;

        const cartDrawer = document.querySelector('cart-drawer');

        this.button.setAttribute('aria-disabled', 'true');
        this.button.classList.add('loading');
        if (this.errorEl) {
          this.errorEl.textContent = '';
          this.errorEl.hidden = true;
        }

        const sections = cartDrawer
          ? cartDrawer.getSectionsToRender().map((section) => section.id)
          : ['cart-drawer', 'cart-icon-bubble'];

        const body = JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: sections,
          sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              if (this.errorEl) {
                this.errorEl.textContent = response.description || response.message || window.cartStrings.error;
                this.errorEl.hidden = false;
              }
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'flowra-cart-drawer-addon',
              productVariantId: variantId,
              cartData: response,
            });

            if (cartDrawer) {
              cartDrawer.renderContents(response);
            } else {
              window.location = window.routes.cart_url;
            }
          })
          .catch((e) => {
            console.error(e);
            if (this.errorEl) {
              this.errorEl.textContent = window.cartStrings.error;
              this.errorEl.hidden = false;
            }
          })
          .finally(() => {
            if (this.button) {
              this.button.classList.remove('loading');
              this.button.removeAttribute('aria-disabled');
            }
          });
      }
    }
  );
}
